var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1666 11.6666C14.1666 12.1269 13.7936 12.5 13.3333 12.5C12.8731 12.5 12.5 12.1269 12.5 11.6666V8.67849L7.2559 13.9226C6.93047 14.248 6.40283 14.248 6.07739 13.9226C5.75195 13.5971 5.75195 13.0695 6.07739 12.7441L11.3215 7.49998H8.33331C7.87308 7.49998 7.49998 7.12688 7.49998 6.66665C7.49998 6.20641 7.87308 5.83331 8.33331 5.83331H13.3333C13.5625 5.83331 13.7701 5.92586 13.9208 6.07563C13.922 6.0768 13.9232 6.07798 13.9243 6.07916C14.0034 6.15865 14.063 6.2501 14.1034 6.34766C14.1442 6.44592 14.1666 6.55365 14.1666 6.66665V11.6666Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.c3b8ec0219b6bd13bf0ed8454ce76f7b.svg";
export { ForwardRef as ReactComponent };